import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import {
  loadSettings,
  saveSettings,
  updateSettingsLocally,
  clearSettings,
  setError,
  UserSettings,
} from '../store/slices/settingsSlice';

export const useSettings = () => {
  const { settings, isLoading, error } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const fetchSettings = useCallback(async () => {
    return dispatch(loadSettings());
  }, [dispatch]);

  const updateSettings = useCallback(async (newSettings: Partial<UserSettings>) => {
    // Update locally first for immediate UI response
    dispatch(updateSettingsLocally(newSettings));
    
    // Then save to database
    return dispatch(saveSettings(newSettings));
  }, [dispatch]);

  const updateSettingsLocal = useCallback((newSettings: Partial<UserSettings>) => {
    dispatch(updateSettingsLocally(newSettings));
  }, [dispatch]);

  const resetSettings = useCallback(() => {
    dispatch(clearSettings());
  }, [dispatch]);

  const clearError = useCallback(() => {
    dispatch(setError(null));
  }, [dispatch]);

  return {
    settings,
    isLoading,
    error,
    loadSettings: fetchSettings,
    saveSettings: updateSettings,
    updateSettingsLocal,
    resetSettings,
    clearError,
  };
};